export default {
    VERTICAL: 'orientation-vertical',
    HORIZONTAL: 'orientation-horizontal',
};
//# sourceMappingURL=orientations.js.map